export enum SituacaoOrdemServicoEnum {

  ABERTO = "Aberto",
  CONCLUIDO = "Concluído",
  FECHADO = "Fechado",
  REABERTO = "Reaberto"
}
